var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobsSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.713 17.291l-2.484-2.563a6.678 6.678 0 001.338-3.987C22.567 7.038 19.51 4 15.783 4 12.057 4 9 7.038 9 10.74c0 3.703 3.057 6.741 6.783 6.741 1.53 0 2.962-.475 4.013-1.33l2.58 2.564c.19.19.477.285.669.285.19 0 .477-.095.668-.285.383-.474.383-1.044 0-1.424zm-12.707-6.55c0-2.659 2.198-4.842 4.873-4.842 2.675 0 4.873 2.183 4.873 4.842a4.87 4.87 0 01-1.433 3.417 4.931 4.931 0 01-3.44 1.424c-2.77 0-4.873-2.183-4.873-4.841z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.1c-.1.5-.5.9-1 .9H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h7.6l1.5 1.5c.6-.4 1.3-.6 2-.8L11.7.3c-.2-.2-.4-.3-.7-.3H3C1.3 0 0 1.3 0 3v16c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3v-.1c-.6.1-1.2.2-1.8.2H16z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11c-.6 0-1 .4-1 1s.4 1 1 1h3.2c-.2-.6-.3-1.3-.3-2H5zM9.1 15H5c-.6 0-1 .4-1 1s.4 1 1 1h5.7c-.6-.6-1.2-1.2-1.6-2zM7 7H5c-.6 0-1 .4-1 1s.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1z",
    fill: "#000"
  })));
}
export default SvgJobsSearch;